import { render, staticRenderFns } from "./BatteryStatus.vue?vue&type=template&id=6e0b31d0&"
import script from "./BatteryStatus.vue?vue&type=script&lang=js&"
export * from "./BatteryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e0b31d0')) {
      api.createRecord('6e0b31d0', component.options)
    } else {
      api.reload('6e0b31d0', component.options)
    }
    module.hot.accept("./BatteryStatus.vue?vue&type=template&id=6e0b31d0&", function () {
      api.rerender('6e0b31d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Device/BatteryStatus.vue"
export default component.exports